import { useEffect, useState } from 'react';
import { getReferralsPrograms } from '../../../redux/api/referred';

const useReferralsPrograms = () => {
    const [dataReferralsPrograms, setDataReferralsPrograms] = useState(null);

    useEffect(() => {
        if (!dataReferralsPrograms) {
            getData();
        }
    }, [dataReferralsPrograms]);

    const getData = async () => {
        try {
            const response = await getReferralsPrograms();

            if (!response || response.length === 0) {
                setDataReferralsPrograms([]);
                return;
            }

            setDataReferralsPrograms([
                {
                    id: '1',
                    name: 'Selecciona el programa a referir',
                },
                ...response,
            ]);
        } catch (error) {
            console.error('Error fetching referral programs:', error);
            setDataReferralsPrograms([]);
        }
    };

    return {
        dataReferralsPrograms,
    };
};

export default useReferralsPrograms;
